/**
 * Treffas design tokens — JS source of truth for MUI theme and sx props.
 * CSS mirror: src/assets/css/treffas.css
 * @see docs/DESIGN_SYSTEM.md
 */

const treffas = {
  colors: {
    brand: {
      primary: "#1A72F6",
      primaryHover: "#1560D4",
      primarySoft: "#E8F0FF",
      navy: "#1C2A3C",
      navyHover: "#152030",
    },
    text: {
      primary: "#1E1E20",
      strong: "#19181B",
      secondary: "#6E757C",
      muted: "#697077",
      disabled: "#A0A6AB",
      inverse: "#FFFFFF",
      tabActive: "#1D1B1B",
    },
    background: {
      default: "#FFFFFF",
      subtle: "#FAFAFA",
      elevated: "#F4F5F6",
      inverse: "#19181B",
    },
    border: {
      default: "#EAECEF",
      strong: "#DBDCE1",
      focus: "#1A72F6",
    },
    semantic: {
      success: "#00AB41",
      successSoft: "#E8F8EE",
      error: "#E92C2C",
      errorSoft: "#FDECEC",
      warning: "#FFA600",
      info: "#1A72F6",
    },
    gray: {
      50: "#FAFAFA",
      100: "#F4F4F4",
      200: "#EAECEF",
      300: "#DBDCE1",
      400: "#D9DBE9",
      500: "#A0A6AB",
      600: "#838383",
      700: "#6E757C",
      800: "#4A5056",
      900: "#1E1E20",
    },
  },

  typography: {
    fontFamily: {
      body: "Karla, sans-serif",
      heading: '"GrenetteProRegular", sans-serif',
      headingMedium: '"GrenetteProSemiBold", sans-serif',
    },
    fontSize: {
      xs: "12px",
      sm: "13px",
      md: "14px",
      base: "15px",
      lg: "16px",
      xl: "18px",
      "2xl": "20px",
      "3xl": "28px",
    },
    fontWeight: {
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    lineHeight: {
      tight: 1.25,
      normal: 1.5,
      relaxed: 1.75,
    },
  },

  spacing: {
    0: "0px",
    1: "4px",
    2: "8px",
    3: "12px",
    4: "16px",
    5: "20px",
    6: "24px",
    8: "32px",
    10: "40px",
    12: "48px",
    16: "64px",
    20: "80px",
  },

  radius: {
    sm: "6px",
    md: "10px",
    lg: "12px",
    xl: "16px",
    pill: "50px",
    full: "9999px",
  },

  shadow: {
    sm: "0px 4px 12px rgba(0, 0, 0, 0.06)",
    md: "0px 12px 24px rgba(0, 0, 0, 0.12)",
    fab: "0px 12px 24px rgba(0, 0, 0, 0.2)",
    focus: "0 0 0 3px rgba(26, 114, 246, 0.25)",
  },

  /** Standard MUI breakpoints only — use for responsive up/down. */
  breakpoints: {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536,
  },

  /**
   * Max-width container caps (px). Not breakpoints.
   * Prefer these over legacy keys like bp, tcal, etc.
   */
  layout: {
    clientPortal: 640,
    packageList: 678,
    appointmentForm: 680,
    pageTablet: 768,
    editor: 820,
    content: 840,
    invoiceForm: 880,
    booking: 918,
    billing: 922,
    container: 926,
    posts: 940,
    invoice: 960,
    calendar: 1200,
    page: 1320,
  },

  button: {
    height: {
      sm: "38px",
      md: "46px",
      lg: "48px",
    },
    paddingX: {
      sm: "16px",
      md: "24px",
      lg: "32px",
    },
  },
};

export default treffas;
